import React from "react";
import Modal from "../../components/ui/Modal";
import FormMoreInfo from "../../components/FormMoreInfo/FormMoreInfo";

const ModalMoreInfoSL = ({ visible, onClose, onSubmit, title, submitLabel }) => {
  const handleSubmit = async (data) => {
    await onSubmit(data);
  };

  return (
    <Modal
      title={title}
      visible={visible}
      onClose={onClose}
    >
      <FormMoreInfo onSubmit={handleSubmit} submitLabel={submitLabel} />
    </Modal>
  );
};

export default ModalMoreInfoSL;
